import React, { useRef } from 'react';
import styles from './Modal.module.css';
import loader from '../../assets/loader2.svg';

const Modal = (props) => {

    const cancelBtn = useRef();

  const unfollowClickHandler = () => {
        cancelBtn.current.disabled = true;
        props.confirm();
    }

    return (
        <div className={styles.main}>
            <div className={styles.modal}>
                <div className={styles.profilePic}>
                    <img src={props.imageUrl} alt="display" />
                </div>
                <div className={styles.message}>
                    {props.message}
                </div>
                <div className={styles.action}>
                    <button id={styles.unfollow} onClick={unfollowClickHandler} disabled={props.clicked} 
                    style={props.clicked ? {color: '#fd001730'} : null}>
                        {props.action}
                        {props.clicked ?
                        <img src={loader} alt="loader" width="20" height="20" 
                        style={{position:'absolute', transform: 'translate(-43px, 0px)'}} />
                        :null
                        }
                        
                    </button>
                    <button onClick={props.closeModal} ref={cancelBtn}>Cancel</button>
                </div>
            </div>
        </div>
    )
}

export default Modal;